/* eslint-disable */
import {
  Autocomplete,
  Avatar,
  Button,
  Group,
  MantineColor,
  Modal,
  MultiSelect,
  Select,
  SelectItemProps,
  Text,
} from "@mantine/core";

import ModalHeader from "components/ModalHeader";

import { useQueryClient } from "@tanstack/react-query";
import AddLeaveRequestForm from "./formCustomAddPolicy";

type AddCustomPolicyModalProps = {
  addOpen: boolean;
  onClose: () => void;
};

function AddCustomPolicyModal({ addOpen, onClose }: AddCustomPolicyModalProps) {
  const queryClient = useQueryClient();

  return (
    <Modal
      opened={addOpen}
      onClose={onClose}
      size="lg"
      withCloseButton={false}
      transitionDuration={300}
      centered
      overlayOpacity={0.5}
    >
      <ModalHeader
        title={`New Custom Policy`}
        onClose={onClose}
        ariaLabel="Close add members modal"
      />

      <AddLeaveRequestForm onClose={onClose} />
    </Modal>
  );
}

export default AddCustomPolicyModal;
